import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import "./Header.scss";
import { Menu } from "./icons";
import { NavBarLinks } from "./NavBarLinks";

export const Header = ({
  className = "",
  hideRoot = false,
  isOpen = false,
  linkUsing = NavLink,
}) => {
  const [open, setOpen] = useState(isOpen);

  const toggleBar = () => setOpen((open) => !open);

  return (
    <div className="navigation-bar block-font">
      <div
        className="desktop-nav navbar__container flex z2 border-bottom mxn3 fixed top-0 left-0 right-0 fade-in"
        style={{ backgroundColor: `var(--app-background-rgb)` }}
      >
        <NavBarLinks
          hideRoot={hideRoot}
          isMobile={false}
          toggleFunction={toggleBar}
          linkUsing={linkUsing}
        />
      </div>

      <div
        className={`${
          open ? "open" : ""
        } mobile-nav navbar__container flex z2 border-bottom mxn3 fixed top-0 left-0 right-0 fade-in bg-primary`}
      >
        <div className="navbar__container__chapters flex flex-row col-12 justify-end">
          <button className="mobile__button" onClick={toggleBar}>
            <Menu isOpen={open} />
          </button>
        </div>
      </div>

      {open && (
        <div className="mobile-nav mobile__menu__overlay">
          <NavBarLinks
            hideRoot={hideRoot}
            isMobile={true}
            toggleFunction={toggleBar}
            linkUsing={linkUsing}
          />
        </div>
      )}
    </div>
  );
};
